"use strict";

module.exports = function (row) {
  var id = this.opts.uniqueKey;
  return !!this.selectedRows.find(function (Row) {
    return Row[id] === row[id];
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/is-row-selected.js
// module id = 912
// module chunks = 0